import React from 'react';
import ErrorCircle from '../../_styles/images/error-circle.svg';
export default function CardMessage(props) {
  const { fullWidth, message } = props;
  
  return (
    <div className={`max-cards-message ${fullWidth ? 'full-width' : ''}`}>
      <div className='warning-icon'>
      <img className='tick-icon' src={ErrorCircle} alt="selected" />
      </div>
      <div className='warning-text'>{message}</div>
    </div>
  );
}